import Service from '../../services'
import Cart from './Cart'

const state = {
  fbAuth: {
    status: '',
    authResponse: {
      accessToken: undefined,
      signedRequest: undefined,
      userID: undefined
    }
  },
  userDetail: {
    fb_id: undefined,
    email: undefined,
    phone: undefined,
    firstname: undefined,
    lastname: undefined,
    access_token: undefined,
    fb_access_token: undefined,
    fb_expiresIn: undefined,
    fb_data_access_expiration_time: undefined,
    is_address: undefined
  },
  loginDialog: false
}

const getters = {
  getUserDetail: (state, getters) => {
    return getters.state.userDetail
  }
}

const actions = {
  onFbRegister({ commit }, data) {
    var postData = {}
    postData = { ...data.auth, ...data.data }
    // console.log('onFbRegister', postData)
    return Service.auth.fbRegister(postData).then((res) => {
      if (res.status === 200) {
        commit('setAuth', data.auth)
        commit('setUserDetail', res.data)
      }
    })
  },
  logOut({ commit }) {
    commit('clearAuth')
    return true
  },
  saveAddress({ commit }, data) {
    commit('setAddress', data)
    return true
  }
}

const mutations = {
  loginDialogHandle(state, data) {
    state.loginDialog = data
  },
  setAuth(state, data) {
    state.fbAuth = data
  },
  setAddress(state, data) {
    state.userDetail.is_address = data
  },
  setUserDetail(state, data) {
    state.userDetail = data
  },
  clearAuth(state) {
    localStorage.removeItem('vuex')
    state.fbAuth = {
      status: '',
      authResponse: {
        accessToken: undefined,
        signedRequest: undefined,
        userID: undefined
      }
    }
    state.userDetail = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
